import * as React from "react";
function SvgBlog(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" width={32} height={32} rx={6} />
      <path
        fill="#fff"
        d="M11.9 20.1L7 25v-6.78C5.13 17 4 15.47 4 13.75 4 10 9.37 7 16 7s12 3 12 6.75-5.37 6.75-12 6.75a20.66 20.66 0 01-4.1-.4z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBlog);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
